import { BigNumber } from 'ethers';
import * as plugins from '../../../Fct/pluginsExport';
import createMulticallPlugin from './generic/createMulticallPlugin';
export var EthTransfers = createMulticallPlugin({
    plugin: plugins.Utility.actions.SendETH,
    protocol: 'KIROBO_MULTICALL',
    type: 'LIBRARY',
    method: 'transfers',
    name: 'ethTransfers',
    config: {
        params: [
            { key: 'to', multicallKey: 'to' },
            { key: 'value', multicallKey: 'value' },
        ],
        tupleName: 'transfers',
    },
    estimateGasFromPlugins: function (plugins, chainId) {
        // 1 transfer - 36000
        var gas = BigNumber.from(plugins.length).mul(36000);
        if (chainId === '42161') {
            gas = gas.mul(13);
        }
        return gas.toString();
    },
});
